import React, { useState } from 'react';
import { Modal, Form, Button, Message, Label, Icon, Input } from 'semantic-ui-react';
import './VideoLibrary.css';

function parseTags(rawTags) {
    if (!rawTags) return [];
    return rawTags.flatMap((tag) => {
        try { const p = JSON.parse(tag); return Array.isArray(p) ? p : [tag]; }
        catch { return [tag]; }
    });
}

export function VideoEditModal({ video, onClose, onUpdate, actionError }) {
    const [title, setTitle] = useState(video.title || '');
    const [description, setDescription] = useState(video.description || '');
    const parsedOriginalTags = parseTags(video.tags);
    const [tags, setTags] = useState(parsedOriginalTags);
    const [tagInput, setTagInput] = useState('');
    const [saving, setSaving] = useState(false);

    const handleTagKeyDown = (e) => {
        if (e.key === 'Enter' || e.key === ',') {
            e.preventDefault();
            addTag();
        }
    };

    const addTag = () => {
        const trimmed = tagInput.trim().replace(/,$/, '');
        if (trimmed && !tags.includes(trimmed)) {
            setTags([...tags, trimmed]);
        }
        setTagInput('');
    };

    const removeTag = (tag) => {
        setTags(tags.filter((t) => t !== tag));
    };

    const handleSubmit = async () => {
        const payload = {};
        if (title.trim() !== (video.title || '')) payload.title = title.trim();
        if (description.trim() !== (video.description || '')) payload.description = description.trim();

        const origTags = JSON.stringify(parsedOriginalTags);
        const newTags = JSON.stringify(tags);
        if (newTags !== origTags) payload.tags = tags;

        setSaving(true);
        await onUpdate(video.id, payload);
        setSaving(false);
    };

    return (
        <Modal open onClose={onClose} size="small">
            <Modal.Header>Edit Video</Modal.Header>
            <Modal.Content>
                {actionError && (
                    <Message negative>
                        <p>{actionError}</p>
                    </Message>
                )}
                <Form>
                    <Form.Field required>
                        <label>Title</label>
                        <Input
                            value={title}
                            onChange={(e) => setTitle(e.target.value)}
                            placeholder="Video title"
                        />
                    </Form.Field>
                    <Form.Field>
                        <label>Description</label>
                        <Form.TextArea
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                            placeholder="Optional description"
                        />
                    </Form.Field>
                    <Form.Field>
                        <label>Tags</label>
                        <Input
                            value={tagInput}
                            onChange={(e) => setTagInput(e.target.value)}
                            onKeyDown={handleTagKeyDown}
                            onBlur={addTag}
                            placeholder="Type a tag and press Enter or comma"
                        />
                        <div className="video-tags">
                            {tags.map((tag) => (
                                <Label key={tag} className="video-tag-label">
                                    {tag}
                                    <Icon name="delete" onClick={() => removeTag(tag)} className="video-tag-remove" />
                                </Label>
                            ))}
                        </div>
                    </Form.Field>
                </Form>
            </Modal.Content>
            <Modal.Actions>
                <Button onClick={onClose} disabled={saving}>Cancel</Button>
                <Button primary loading={saving} disabled={saving} onClick={handleSubmit}>
                    Save
                </Button>
            </Modal.Actions>
        </Modal>
    );
}
